import { queryOptions } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import handle401 from '../../handle-401';
import HttpClient from '../../../Api/HttpClient';

export function listChats({ page = 1, pageSize = 25, sort = 'createdAt:desc', filters = {} } = {}) {
  return queryOptions({
    queryKey: ['assistant-chats', page, pageSize, sort, filters],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.listAssistantChats({ page, pageSize, sort, filters });

      return data;
    }),
  });
}

export function getChat({ chatId }) {
  return queryOptions({
    queryKey: ['assistant-chat', chatId],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getAssistantChat({ chatId });

      return data;
    }),
  });
}

export function getChatMessage({ chatId, messageId }) {
  return queryOptions({
    queryKey: ['assistant-chat-message', chatId, messageId],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getAssistantChatMessage({ chatId, messageId });

      if (data.prompt_type === 'pain_statement' && data.status === 'completed') {
        return {
          ...data,
          output_json: {
            ...data.output_json,
            pain_statement: {
              ...data.output_json.pain_statement,
              problem_one_liner: data.output_json.pain_statement.problem_one_liner.map((item) => {
                const [stakeholder, role] = (item.stakeholder || '').split(', ');
                return {
                  id: uuidv4(),
                  ...item,
                  stakeholder,
                  role,
                };
              }),
            },
          },
        };
      }

      return data;
    }),
  });
}
